import { Module, VuexModule, Mutation } from 'vuex-module-decorators';

@Module({ namespaced: true })
export default class App extends VuexModule {
  waitingForConnection = false;
  online = false;
  isLoading = false;

  visitorId = -1;

  get getIsLoading() {
    return this.isLoading;
  }

  @Mutation
  UNSET_LOADING() {
    this.isLoading = false;
  }

  @Mutation
  SET_LOADING() {
    this.isLoading = true;
  }

  @Mutation
  SET_ONLINE() {
    this.online = true;
  }

  @Mutation
  SET_OFFLINE() {
    this.online = false;
  }

  @Mutation
  SET_WAITING_FOR_CONNECTION() {
    this.waitingForConnection = true;
  }

  @Mutation
  UNSET_WAITING_FOR_CONNECTION() {
    this.waitingForConnection = false;
  }

  @Mutation
  SET_VISITOR_ID(visitorId: number) {
    this.visitorId = visitorId;
  }
}
